<div *ngIf="this.loadingService.getLoading()" class="cssload-container">
  <div class="cssload-speeding-wheel">
    <img src="../../../../assets/images/logo/spinner-logo.svg" alt="">
  </div>
</div>
